function ActivityLogIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4189 14.7321C20.4189 18.3101 18.3099 20.4191 14.7319 20.4191H6.94988C3.36288 20.4191 1.24988 18.3101 1.24988 14.7321V6.93212C1.24988 3.35912 2.56388 1.25012 6.14288 1.25012H8.14288C8.86088 1.25112 9.53688 1.58812 9.96688 2.16312L10.8799 3.37712C11.3119 3.95112 11.9879 4.28912 12.7059 4.29012H15.5359C19.1229 4.29012 20.4469 6.11612 20.4469 9.76712L20.4189 14.7321Z"
        stroke="#777777"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.48096 13.463H15.216"
        stroke="#777777"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ActivityLogIcon